import React from "react";
import { Button, Typography, Box, useMediaQuery } from "@mui/material";
import { useParams } from "react-router-dom";

const Paragraph = ({ descrizione }) => {
  const isMobile = useMediaQuery("(max-width: 768px)");

  return (
    <Box p={isMobile ? 3 : 3}>
      <Typography
        fontSize={undefined}
        variant={isMobile ? "h5" : "h5"}
        gutterBottom
      >
        Descrizione
      </Typography>
      <Typography variant="body1" fontSize={15} lineHeight={1.5} paragraph>
        {descrizione}
      </Typography>
      <Button
        variant="contained"
        color="info"
        href="tel:08119640374"
        sx={{ mt: 2 }}
      >
        081 196 40 374{" "}
      </Button>
    </Box>
  );
};

export default Paragraph;
